import { ExtendedFormGroup, ExtendedFormGroupOptions, SearchSelectField, SearchSelectFieldOptions } from '@antony/ng-forms/core';

interface SelectFormModel<TValue extends {}> {
  data: TValue;
}

export interface SelectFormOptions<TValue extends {}> extends ExtendedFormGroupOptions<SelectFormModel<TValue>> {
  data: SearchSelectFieldOptions<TValue>;
}

export class SelectForm<TValue extends {}, TOptions extends SelectFormOptions<TValue> = SelectFormOptions<TValue>> extends ExtendedFormGroup<SelectFormModel<TValue>, TOptions> {
  constructor(options: TOptions) {
    super({
      ...options,
      controls: {
        data: new SearchSelectField<TValue>({
          icon: 'APP.ACTIONS.SELECT.ICON',
          label: 'APP.ACTIONS.SELECT.LABEL',
          ...options.data,
          required: true,
        }),
      },
    });
  }
}
